import { Static, Type } from '@sinclair/typebox';
import { MinimalUser, minimalUserSchema } from '../../shared/user/user.schema';

export const blockedUserSchema = Type.Object({
  id: Type.String({
    description: 'Unique identifier of the blocked user for the provider. Usually an internal identifier used by the API only.',
  }),
  object: Type.Literal('BlockedUser'),
  status: Type.Union([Type.Literal('blocked'), Type.Literal('unblocked')], {
    description:
      'Block status of the user resulting from the change. `blocked` when the account owner blocked the user, `unblocked` when it unblocked a user it had blocked.',
  }),
  user: Type.Object(minimalUserSchema, { description: 'The user blocked or unblocked by the account owner.' }),
  created_at: Type.Optional(
    Type.String({ description: 'Date and time when the block was created, when the provider publishes it.' }),
  ),
});

export type BlockedUser<UserSpecifics = unknown> = Omit<Static<typeof blockedUserSchema>, 'user'> & {
  user: MinimalUser<UserSpecifics>;
};
